import { createGlobalStyle, css } from 'styled-components'

import fonts_import_css from './fonts_import_css'
import antd_custom_css from './antd/antd_custom_css'


const global_css = css`
* {
  box-sizing: border-box;
}
html {
  font-size: 10px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background-color: ${props => props.is_widget ? 'transparent' : props.theme.cPaleGray};
  box-sizing: border-box;
  scroll-behavior: smooth;
}
body {
  margin: 0;

  font-family: ${props => props.theme.fontFamilyBase};
  font-size: ${props => props.theme.fontSizeBase};
  line-height: ${props => props.theme.lineHeightBase};
  background-color: ${props => props.is_widget ? 'transparent' : props.theme.cPaleGray};
  color: ${props => props.theme.cTextColor};
}
#root {
  transition: filter .12s ease;
}

.vh, .visual-hidden {
    position: absolute !important;
    clip: rect(1px, 1px, 1px, 1px);
    padding: 0 !important;
    border: 0 !important;
    height: 1px !important;
    width: 1px !important;
    overflow: hidden;
}
a{
  transition: color .2s ease;
  cursor: pointer;
  color: ${props => props.theme.cLinkDarkBlue};
  text-decoration: none;
}
a:hover{
  color: ${props => props.theme.cLinkHover};
  text-decoration: none;
}
a.lightBlue,
a.lightBlue:hover {
  color: ${props => props.theme.cLinkLightBlue};
}

a:focus {
  ${p => p.theme.is_keyboard_user && css`
  outline: 1px #03B0F6 solid;
`};
}
a:visited {
  opacity: .978;
}
input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
${p => p.theme.is_keyboard_user ? css`
*:hover,
*:focus,
*:active {
  outline-color: ${p => p.theme.cBlue};
}
` : css`
*:hover,
*:focus,
*:active {
  outline: 0;
}

*::placeholder: {
  color: ${p => p.theme.input_placeholder_color};
}
`}
button,
input,
select,
textarea {
  margin: 0;
  font-size: 100%;
  vertical-align: middle;
}
button,
input {
  overflow: visible;
  line-height: normal;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  padding: 0;
  border: 0;
}
button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}
select,
button,
input[type="button"],
input[type="reset"],
input[type="submit"],
input[type="radio"],
input[type="checkbox"] {
  cursor: pointer;
}
input[type="search"] {
  box-sizing: border-box;
  -webkit-appearance: textfield;
}
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
textarea {
  overflow: auto;
  vertical-align: top;
}
ul{
  margin: 0;
  padding: 0;
  list-style: none;
}

.hidden-number-spinbox input::-webkit-outer-spin-button,
.hidden-number-spinbox input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.hidden-number-spinbox input[type=number] {
  -moz-appearance:textfield;
}

.clickable {
  cursor: pointer;
}
`

export default createGlobalStyle`

${fonts_import_css};

/* если передан id контейнера, то стили будут применены только к этому контейнеру */
${p => p.contain_styles_in_css_id ? css`
  #${p.contain_styles_in_css_id} {
    ${global_css}
  }
` : global_css}

/* antd стили нельзя держать в контейнере, потому что тогда стили модалов, селектов и прочих дропдаунов не будут работать */
${antd_custom_css}

.Toastify__toast-container--top-center:has(div.toast_fullWidth) {
  max-width: 700px;
  width: 100%;
}

:root {
  --toastify-color-progress-light: linear-gradient(
    to right,
    #1b5366,
    #c80600,
    #fe7a24,
    #00aff5
  );
}
`
